import { StaffType } from 'types/staff'

export const FETCH_STAFFS = 'FETCH_STAFFS'
export const fetchStaffsAction = (staffs: StaffType[]) => {
  return {
    type: 'FETCH_STAFFS',
    payload: staffs,
  }
}

export const INIT_STAFFS = 'INIT_STAFFS'
export const initStaffsAction = () => {
  return {
    type: 'INIT_STAFFS',
    payload: null,
  }
}
